import React from "react";
import { observer } from "mobx-react-lite";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { Container, Body } from "./SessionReport.styles";
import { SessionReportHeader } from "./SessionReportHeader";
import { SessionReportForm } from "./SessionReportForm";
import { SessionReportDetails } from "./SessionReportDetails";
import { SessionReportSessionPlan } from "./SessionReportSessionPlan";
import { SessionReportTargets } from "./SessionReportTargets";
import { SessionReportWellbeing } from "./SessionReportWellbeing";
import { SessionReportInvolvement } from "./SessionReportInvolvement";
import { SessionReportDocuments } from "./SessionReportDocuments";
import { SessionReportFooter } from "./SessionReportFooter";
import { StudentSessionAQACertificatesView } from "Views/Shared/Views/StudentSessionAQACertificate/StudentSessionAQACertificatesView";
import { StudentBehavioursView } from "Views/Students/Student/StudentReports/Form/Views/StudentBehavioursView";

export interface SessionReportViewProps {
    viewModel: IStudentSessionReportViewModel;
}

export const SessionReport: React.FC<SessionReportViewProps> = observer(({ viewModel }) => (
    <Container>
        <SessionReportHeader viewModel={viewModel} />
        <Body>
            <SessionReportForm viewModel={viewModel} />
            <SessionReportDetails viewModel={viewModel} />
            <SessionReportSessionPlan viewModel={viewModel} />
            <SessionReportTargets viewModel={viewModel} />
            <StudentSessionAQACertificatesView viewModel={viewModel.studentSessionAQACertificatesViewModel} />
            <StudentBehavioursView showStudentBehaviours={viewModel.showStudentBehaviours} viewModels={viewModel.studentBehaviourViewModels} />
            <SessionReportWellbeing viewModel={viewModel} />
            <SessionReportInvolvement viewModel={viewModel} />
            <SessionReportDocuments viewModel={viewModel} />
        </Body>
        <SessionReportFooter viewModel={viewModel} />
    </Container>
));
